import NorthSquare1 from '../Devant/Devant (1).webp'
import NorthSquare2 from '../Devant/Devant (2).webp'
import NorthSquare3 from '../Devant/Devant (3).webp'
import NorthSquare4 from '../Devant/Devant (4).webp'
import NorthSquare5 from '../Devant/Devant (5).webp'
import NorthSquare6 from '../Devant/Devant (6).webp'
import NorthSquare7 from '../Devant/Devant (7).webp'
import NorthSquare8 from '../Devant/Devant (8).webp'
import NorthSquare9 from '../Devant/Devant (9).webp'
import NorthSquare10 from '../Devant/Devant (10).webp'


const NorthSquareimages =[
NorthSquare1,NorthSquare2,NorthSquare3,NorthSquare4,NorthSquare5,NorthSquare6,NorthSquare7,NorthSquare8,NorthSquare9,NorthSquare10
]

export default NorthSquareimages;